import { render, staticRenderFns } from "./peiebaobiao.vue?vue&type=template&id=ee6b9108&scoped=true"
import script from "./peiebaobiao.vue?vue&type=script&lang=js"
export * from "./peiebaobiao.vue?vue&type=script&lang=js"
import style0 from "./peiebaobiao.vue?vue&type=style&index=0&id=ee6b9108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6b9108",
  null
  
)

export default component.exports